/**
 * /admin/calendar — embeds the shared Google Calendar (aircraft
 * schedule with flights, ferries and blackouts) in an iframe. Shared
 * page: admins and regular users both see it in the top nav. The
 * route still lives under `/admin/calendar` to match the pattern used
 * by other shared utility screens (e.g. `/admin/passengers`).
 */
const CALENDAR_SRC =
  "https://calendar.google.com/calendar/embed?" +
  "src=Y19jNThlNzFlMWZlMmE0NTIxNDJmYzUyZGNhOTExY2UzYWFlMzA4NzBjNjgzZDQwYjcyMWVjODBlN2MwYzU0M2VlQGdyb3VwLmNhbGVuZGFyLmdvb2dsZS5jb20" +
  "&ctz=America%2FSantiago" +
  "&wkst=1" +
  "&showTitle=0&showPrint=0&showCalendars=0&showTz=0" +
  "&mode=AGENDA" +
  "&color=%23ad1457";

export function Calendario() {
  return (
    <div className="space-y-5">
      <header>
        <div className="mb-2 h-[3px] w-8 rounded-full bg-brand-700" />
        <h1 className="text-2xl font-semibold tracking-tight text-brand-900">
          Calendario
        </h1>
        <p className="mt-1 text-sm text-slate-600">
          Vista del Google Calendar compartido — vuelos aprobados, ferries
          y bloqueos.
        </p>
      </header>

      <div className="overflow-hidden rounded-lg border border-slate-200 bg-white shadow-sm">
        {/* Mobile: fit to the visible viewport so it ends at the bottom
            of the phone screen (above the mobile bottom nav). Desktop:
            fixed 900px height as originally designed. */}
        <iframe
          src={CALENDAR_SRC}
          title="Google Calendar — AltaJet"
          className="block w-full border-0 h-[calc(100dvh-220px)] min-h-[360px] md:h-[900px]"
          frameBorder={0}
          scrolling="no"
        />
      </div>
    </div>
  );
}
